import React from "react";
import { useHistory } from "react-router-dom";
import { IService } from "../../../store/userService/types";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import { getFormattedDate } from "../../../util/dateFormatting";
import { useTranslation } from "react-i18next";

const ServiceItem = (props: { service: IService, isTUService: boolean, id: string }) => {
    const history = useHistory();
    const { t: tLang } = useTranslation();
    const supportInternational = useSelector(
        (state: ApplicationState) =>
            state.configurationState &&
            state.configurationState.configuration &&
            state.configurationState.configuration.partnerConfig &&
            state.configurationState.configuration.partnerConfig.supportInternational
    );
    const isL3Authenticated: boolean = useSelector(
        (state: ApplicationState) => state?.csidUserStatusState?.csidUserStatus?.["auth-status"]?.toLocaleLowerCase() === "authenticated" || false
    );

    const country = i18nService.get("Country");
    const showJunkMailAndCreditFreeze = supportInternational ? country === "US" : true;

    if (!showJunkMailAndCreditFreeze && (props.service.displayName === "Credit Freeze Assistance" || props.service.displayName === "Junk Mail Opt-Out")) {
        return <React.Fragment></React.Fragment>;
    }

    const formatDate = (activeLink: String) => {
        if (
            props.service.activeText &&
            (props.service.activeText.toLowerCase().indexOf("last scan") >= 0 || props.service.activeText.toLowerCase().indexOf("last updated") >= 0)
        ) {
            return props.service.activeText.split(":")[0] + ": " + getFormattedDate(i18nService.get("Country"), props.service.activeText.split(":")[1]);
        } else {
            return activeLink;
        }
    };

    const creatActiveText = () => {
        // SOR can exists as a standalone service also, also it's not a TU service, so L3 is not compulsory
        if (props.service.displayName === "Sex Offender Registry Monitoring") {
            return tLang("manageAccount.myServices.Active");
        } else if (props.service.displayName === "Change of Address Monitoring") { // its not TU service, its melisa
            return <React.Fragment>{props.service.activeText && formatDate(props.service.activeText)}</React.Fragment>;
        } else if (props.isTUService && !isL3Authenticated) {
            return tLang("manageAccount.myServices.verifyIdentity");
        } else if (props.service.isLink && props.service.link) {
            const redirectLink = props.service.link.startsWith("/") ? props.service.link : `/${props.service.link}`;
            return (
                <React.Fragment>
                    <a
                        href="#"
                        className="default_link"
                        onClick={(e) => {
                            e.preventDefault();
                            history.push(redirectLink);
                        }}
                    >
                        {props.service.activeText}
                    </a>
                </React.Fragment>
            );
        } else {
            return <React.Fragment>{props.service.activeText && formatDate(props.service.activeText)}</React.Fragment>;
        }
    };

    return (
        <React.Fragment>
            <div role="row" className="data-row row between-sm">
                <div role="gridcell" className="col-xs-12 col-sm flex-grow-null col-no-gutter">
                    <div className="data-label" id={`label-monitor-service-${props.id}`}>
                        {props.service.displayName === "Cyber Claim Support" ? "" : props.service.displayName}
                    </div>
                </div>
                <div className="col-xs-12 col-sm flex-grow-null col-no-gutter">
                    <div role="gridcell" className="data-value" aria-labelledby={`label-monitor-service-${props.id}`}>
                        {props.service.displayName === "Cyber Claim Support" ? "" : creatActiveText()}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ServiceItem;
